import React from 'react';
import {BaseInputProps} from '../..';

import {IoAdd, IoTrashBin} from 'react-icons/io5';
import {useFieldArray, useFormContext} from 'react-hook-form';

import {NestedKeys} from 'shared/types/key-manipulation';

import {Container, Row, Title, Column, Header} from './styles';
import Input from '../input';
import IconButton from 'shared/migration-components/icon-button';

export interface TextSectionProps<T = any> extends BaseInputProps {
  name: NestedKeys<T>;
  detailsUrl?: string;
}

const TextSection: React.FC<TextSectionProps> = ({
  name,
  label,
  border,
  placeholder,
}) => {
  const {control} = useFormContext();
  const {fields, append, remove} = useFieldArray({
    control,
    name: name as string,
  });

  return (
    <Container>
      <Row>
        <Header>
          <Title>{label}</Title>
        </Header>
        <IconButton
          icon={<IoAdd />}
          label="Adicionar"
          variant="filled"
          onClick={() => append('')}
        />
      </Row>
      {fields.map((field, index) => (
        <Column key={field.id}>
          <Input
            {...{
              name: `${name}.${index}`,
              type: 'input',
              border,
              placeholder,
              value: field,
            }}
          />
          <IconButton
            label="Remover"
            icon={<IoTrashBin />}
            onClick={() => remove(index)}
          />
        </Column>
      ))}
    </Container>
  );
};

export default TextSection;
